/*
(function (Drupal, $, once) {

  // configure teh datepicker acordingly
  if ($.datepicker) {
    // from https://github.com/jquery/jquery-ui/blob/main/ui/i18n/datepicker-de.js
    $.datepicker.setDefaults( {
      closeText: "Schließen",
      prevText: "Zurück",
      nextText: "Vor",
      currentText: "Heute",
      monthNames: [ "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember" ],
      monthNamesShort: [ "Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez" ],
      dayNames: [ "Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag" ],
      dayNamesShort: [ "So", "Mo", "Di", "Mi", "Do", "Fr", "Sa" ],
      dayNamesMin: [ "So", "Mo", "Di", "Mi", "Do", "Fr", "Sa" ],
      weekHeader: "KW",
      dateFormat: "dd.mm.yy",
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: "" });
  }

  // job application js
  Drupal.behaviors.jobapplication = {
    attach: function (context, settings) {

      $(once('jobapplication','.job-application', context)).each(function () {


        // Disable holidays until incl. 2026
        let holidays =
          ["2022-12-25","2022-12-26", "2023-01-01", "2023-01-06",
            "2023-04-07", "2023-04-10", "2023-05-01", "2023-05-18",
            "2023-05-29", "2023-06-08", "2023-08-15", "2023-10-03",
            "2023-11-01", "2023-12-25", "2023-12-26", "2024-01-01",
            "2024-01-06", "2024-03-29", "2024-04-01", "2024-05-01",
            "2024-05-09", "2024-05-20", "2024-05-30", "2024-08-15",
            "2024-10-03", "2024-11-01", "2024-12-25", "2024-12-26",
            "2025-01-01", "2025-01-06", "2025-04-18", "2025-04-21",
            "2025-05-01", "2025-05-29", "2025-06-19", "2025-11-03",
            "2025-11-1", "2025-12-25", "2025-12-26", "2026-01-01",
            "2026-01-06", "2026-04-03", "2026-04-06", "2026-05-01",
            "2026-05-14", "2026-06-04", "2026-10-03", "2026-11-01",
            "2026-12-25", "2026-12-26",
          ];
        $( "#edit-timeslot1-date, #edit-timeslot2-date, #edit-timeslot3-date" ).datepicker({
          beforeShowDay: function(date){
            let day = date.getDay();
            let datestring = jQuery.datepicker.formatDate('yy-mm-dd', date);
            if (day == 6 || day == 0) {
              return [ false ]
            }
            return [ holidays.indexOf(datestring) == -1 ]
          }
        });



        let getUrlParameter = function getUrlParameter(sParam) {
          let sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

          for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
          }
          return false;
        };

        let sendData = function sendData(targetPath) {
          let url = targetPath;
          let job_id = getUrlParameter('job_id');
          let job_title = getUrlParameter('job_title');
          let vorname = $('#edit-vorname').val();
          let nachname = $('#edit-nachname').val();
          let e_mail = $('#edit-e-mail').val();
          let tel = $('#edit-telefonnummer').val();
          let date_1 = $('#edit-timeslot1-date').val();
          let time_1 = $('#edit-timeslot1-time').val();
          let date_2 = $('#edit-timeslot2-date').val();
          let time_2 = $('#edit-timeslot2-time').val();
          let date_3 = $('#edit-timeslot3-date').val();
          let time_3 = $('#edit-timeslot3-time').val();


          let checkboxes = ["pflege", "verwaltung", "schulen", "ausbildung", "msd", "familienpflege"];
          checkboxes.forEach(function(checkbox) {
            let value = document.getElementById("edit-" + checkbox);
            if (value) value = value.checked;
            if (value) { url = url + '&' + checkbox + '=true' } else { url = url + '&' + checkbox + '=false'; }
          });

          let personal_data = document.getElementById('edit-personal-data');
          if (personal_data) personal_data = personal_data.checked;
          let offer_data = document.getElementById('edit-offer-other-jobs');
          if (offer_data) offer_data = personal_data.checked;

          if (job_id) url = url +  'job_id=' + job_id;
          if (job_title) url = url + '&job_title=' + job_title;
          if (vorname) { url = url + '&vorname=' + vorname; } else { url = url + '&vorname='; }
          if (nachname) { url = url + '&nachname=' + nachname; } else { url = url + '&nachname='; }
          if (e_mail) { url = url + '&e_mail=' + e_mail + '&open=Per E-Mail'; } else { url = url + '&e_mail='; }
          if (tel) { url = url + '&tel=' + tel + '&open=Per Telefon'; } else { url = url + '&tel=';}
          if (date_1) { url = url + '&date_1=' + date_1 + " " + time_1; } else { url = url + '&date_1='; }
          if (date_2) { url = url + '&date_2=' + date_2 + " " + time_2; } else { url = url + '&date_2='; }
          if (date_3) { url = url + '&date_3=' + date_3 + " " + time_3; } else { url = url + '&date_3='; }
          if (personal_data) { url = url + '&personal_data=true' } else { url = url + '&personal_data=false'; }
          if (offer_data) { url = url + '&offer_data=true' } else { url = url + '&offer_data=false'; }
          window.location.href = url;
        };

        /!**
         * Standard-Bewerbung: Send important data to the more explicit form
         *!/
        $("#more_button").click(function () {
          sendData('/langbewerbung?');
        });

        /!**
         * Initiativbewerbung: Send important data to the more explicit form
         *!/
        $("#more_button_initiativ").click(function () {
          sendData('/initiativbewerbung-lang?');
        });
      });
    }
  }
}(Drupal, jQuery, once));
*/

(function (Drupal, $) {

  // Configure the datepicker accordingly
  if ($.datepicker) {
    $.datepicker.setDefaults({
      closeText: "Schließen",
      prevText: "Zurück",
      nextText: "Vor",
      currentText: "Heute",
      monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni",
        "Juli", "August", "September", "Oktober", "November", "Dezember"],
      monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun",
        "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
      dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch",
        "Donnerstag", "Freitag", "Samstag"],
      dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      weekHeader: "KW",
      dateFormat: "dd.mm.yy",
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: ""
    });
  }

  // Job application JS
  Drupal.behaviors.jobapplication = {
    attach: function (context, settings) {

      // Use Drupal.once instead of jQuery once
      $(once('jobapplication', '.job-application', context)).each(function () {
        // Disable holidays until incl. 2026
        let holidays = [
          "2022-12-25","2022-12-26","2023-01-01","2023-01-06",
          "2023-04-07","2023-04-10","2023-05-01","2023-05-18",
          "2023-05-29","2023-06-08","2023-08-15","2023-10-03",
          "2023-11-01","2023-12-25","2023-12-26","2024-01-01",
          "2024-01-06","2024-03-29","2024-04-01","2024-05-01",
          "2024-05-09","2024-05-20","2024-05-30","2024-08-15",
          "2024-10-03","2024-11-01","2024-12-25","2024-12-26",
          "2025-01-01","2025-01-06","2025-04-18","2025-04-21",
          "2025-05-01","2025-05-29","2025-06-19","2025-11-03",
          "2025-11-01","2025-12-25","2025-12-26","2026-01-01",
          "2026-01-06","2026-04-03","2026-04-06","2026-05-01",
          "2026-05-14","2026-06-04","2026-10-03","2026-11-01",
          "2026-12-25","2026-12-26"
        ];

        $("#edit-timeslot1-date, #edit-timeslot2-date, #edit-timeslot3-date").datepicker({
          beforeShowDay: function(date) {
            let day = date.getDay();
            let datestring = $.datepicker.formatDate('yy-mm-dd', date);
            return [day !== 0 && day !== 6 && holidays.indexOf(datestring) === -1];
          }
        });

        let getUrlParameter = function (sParam) {
          let sPageURL = window.location.search.substring(1);
          let sURLVariables = sPageURL.split('&');
          for (let i = 0; i < sURLVariables.length; i++) {
            let sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
          }
          return false;
        };

        let sendData = function (targetPath) {
          let url = targetPath;
          let job_id = getUrlParameter('job_id');
          let job_title = getUrlParameter('job_title');
          let vorname = $('#edit-vorname').val();
          let nachname = $('#edit-nachname').val();
          let e_mail = $('#edit-e-mail').val();
          let tel = $('#edit-telefonnummer').val();
          let date_1 = $('#edit-timeslot1-date').val();
          let time_1 = $('#edit-timeslot1-time').val();
          let date_2 = $('#edit-timeslot2-date').val();
          let time_2 = $('#edit-timeslot2-time').val();
          let date_3 = $('#edit-timeslot3-date').val();
          let time_3 = $('#edit-timeslot3-time').val();

          let checkboxes = ["pflege", "verwaltung", "schulen", "ausbildung", "msd", "familienpflege"];
          checkboxes.forEach(function(checkbox) {
            let value = document.getElementById("edit-" + checkbox);
            if (value) value = value.checked;
            url += '&' + checkbox + '=' + (value ? 'true' : 'false');
          });

          let personal_data = document.getElementById('edit-personal-data')?.checked || false;
          let offer_data = document.getElementById('edit-offer-other-jobs')?.checked || false;

          if (job_id) url += '&job_id=' + job_id;
          if (job_title) url += '&job_title=' + job_title;
          url += '&vorname=' + (vorname || '');
          url += '&nachname=' + (nachname || '');
          url += '&e_mail=' + (e_mail || '') + (e_mail ? '&open=Per E-Mail' : '');
          url += '&tel=' + (tel || '') + (tel ? '&open=Per Telefon' : '');
          url += '&date_1=' + (date_1 ? date_1 + " " + time_1 : '');
          url += '&date_2=' + (date_2 ? date_2 + " " + time_2 : '');
          url += '&date_3=' + (date_3 ? date_3 + " " + time_3 : '');
          url += '&personal_data=' + personal_data;
          url += '&offer_data=' + offer_data;

          window.location.href = url;
        };

        $("#more_button").click(function () {
          sendData('/langbewerbung?');
        });

        $("#more_button_initiativ").click(function () {
          sendData('/initiativbewerbung-lang?');
        });

      });
    }
  };

}(Drupal, jQuery));
